document.addEventListener('DOMContentLoaded', () => {
    const animateCounter = (element) => {
        const start = parseInt(element.dataset.start);
        const end = parseInt(element.dataset.end);
        const duration = parseInt(element.dataset.duration);
        
        let startTime = null;

        const updateCounter = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = timestamp - startTime;
            const percentage = Math.min(progress / duration, 1);
            
            element.textContent = Math.floor(percentage * (end - start) + start);
            
            if (percentage < 1) {
                requestAnimationFrame(updateCounter);
            }
        };

        requestAnimationFrame(updateCounter);
    };

    // Usa Intersection Observer per attivare l'animazione solo quando il blocco è visibile
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    // Osserva tutti i blocchi counter
    document.querySelectorAll('.wp-block-create-block-counter').forEach(block => {
        observer.observe(block);
    });
});